import { Link, LinkProps } from 'react-router-dom';

export default (props: LinkProps) => <Link {...props} />;
